"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Optional = void 0;
var Optional = /** @class */ (function () {
    function Optional(value) {
        this.value = value;
    }
    Optional.of = function (value) {
        if (Optional.isEmpty(value)) {
            throw new Error("Optional.of doesn't accept undefined or null values. Use Optional.ofNullable instead");
        }
        return new Optional(value);
    };
    Optional.ofNullable = function (value) {
        return new Optional(value);
    };
    Optional.empty = function () {
        // @ts-ignore
        return new Optional(null);
    };
    Optional.isEmpty = function (value) {
        return value === null || value === undefined || typeof value === "undefined";
    };
    Optional.prototype.get = function () {
        if (this.isPresent()) {
            return this.value;
        }
        throw new Error("Exception while trying to get the value of an empty Optional");
    };
    Optional.prototype.isPresent = function () {
        return !Optional.isEmpty(this.value);
    };
    Optional.prototype.isNotPresent = function () {
        return !this.isPresent();
    };
    Optional.prototype.orElse = function (alt) {
        if (this.isPresent()) {
            return this.value;
        }
        return alt;
    };
    return Optional;
}());
exports.Optional = Optional;
//# sourceMappingURL=Optional.js.map